import Vue from 'vue'
import sensors from 'sa-sdk-javascript';
import heatmap from 'sa-sdk-javascript';

const SENSOR_URL = 'http://dataanalysis.zuowenzhitiao.com:8106/sa?project=default';
// const SENSOR_URL = 'http://dataanalysis.zuowenzhitiao.com:8106/sa?project=production';

/**
 *
 *
 * @export （全埋点需要主动开启）
 * @param {*} event_name 事件名 
 * @param {*} properties 对应属性
 * @returns
 */
sensors.init({
    server_url: SENSOR_URL,
    // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
    heatmap_url: heatmap,
    // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
    web_url: SENSOR_URL,
    heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        // 需要 JSSDK 版本号大于 1.7
        clickmap: 'not_collect',
        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        // 需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'not_collect'
    },
    use_app_track: true
});
function postSensors(event_name, properties) {
    properties = Object.assign({ platform_type: 'H5' }, properties)
    sensors.quick('isReady', () => {
        event_name === 'autoTrack' ? sensors.quick('autoTrack') : sensors.track(event_name, properties);
    })
}

Vue.prototype.$sensor = postSensors;
Vue.prototype.$sensorDistinctId = sensors.store.getDistinctId();
